import * as THREE from 'three';
import { G, M, TINT, HP, glowMat, mesh, plate, rib, mergeBones, damp, boneG } from './kit';
/* ============================================================
   MUTTER 母體 —— BOSS・生成
   ============================================================

   剪影：環形托架抱著巨球
   二階段：四瓣外翻・核心直射（天藍→紫）

   由 `tools/port-bosses.mjs` 從 `enemy_sample_ani.html` 機械移植，
   **不要手改這個檔**：要改造型請改原型再重跑移植器，否則 1:1 就斷了。
   驗證：`node tools/port-bosses.mjs --check`。
   ⚠️ 比對只守得住數字與字串，**動畫對不對只能實看**（圖鑑的開發模式）。 */


/* ── BOSS-05 MUTTER 母體 ── ORB＋RING：托架抱著一顆 3.6 單位的球。
   P1 殼閉合，持續生小怪（天藍・支援）→ 打小怪還是打殼是玩家的選擇。
   P2 四瓣外翻，核心直射（紫・範圍）→ 不生了，改成自己打。 */
export function buildMutter(){
  var GLC = glowMat(TINT.azu.hex, 2.2), GLV = glowMat(TINT.vio.hex, 2.3);
  var root = new THREE.Group(), i;
  var cradle = boneG(root, 0, 3.40, 0);
  cradle.add(mesh(G.tor, M.armor, [7.60,7.60,0.70], [0,0,0], [0,HP,0]));
  cradle.add(mesh(G.tor, M.trim,  [8.10,8.10,0.34], [0,0,0], [0,HP,0]));
  for (i = 0; i < 3; i++){
    var a = i*Math.PI * 2/3 + 0.5;
    cradle.add(mesh(G.cyl, M.armor, [0.56,3.60,0.56],
      [Math.sin(a)*2.70, -1.80, Math.cos(a)*2.70], [0.52*Math.cos(a),0,-0.52*Math.sin(a)]));
    cradle.add(mesh(G.box, M.dark, [1.20,0.40,1.20],
      [Math.sin(a)*3.60, -3.44, Math.cos(a)*3.60]));
  }
  var ports = [];
  for (i = 0; i < 4; i++){
    var b = i*Math.PI * 2/4 + 0.78;
    var pm = mesh(G.tor, GLC, [1.10,1.10,0.55], [Math.sin(b)*3.80, 0, Math.cos(b)*3.80], [HP,0,b]);
    pm.userData.noMerge = 1; cradle.add(pm); ports.push(pm);
  }
  /* 四瓣殼：樞紐在球的赤道，翻開之後核心整顆露出來 */
  var shells = [];
  for (i = 0; i < 4; i++){
    var c = i*Math.PI * 2/4;
    var sg = boneG(cradle, 0, 0, 0); sg.rotation.y = c;
    sg.add(plate(M.armor, 2.30, 2.60, 0.60, [0, 1.10, 1.42], -0.42));
    sg.add(plate(M.armor, 1.70, 1.60, 0.50, [0, 2.34, 0.88], -0.90));
    sg.add(rib  (M.armor, 0.14, 2.40, 0.14, [ 1.02, 1.10, 1.58], -0.42));
    sg.add(rib  (M.armor, 0.14, 2.40, 0.14, [-1.02, 1.10, 1.58], -0.42));
    shells.push(sg);
  }
  var core = boneG(cradle, 0, 0, 0);
  var cm = mesh(G.oct, GLV, [3.20,3.20,3.20], [0,0,0]); cm.userData.noMerge = 1; core.add(cm);
  core.add(mesh(G.tor, M.trim, [3.90,3.90,0.34], [0,0,0], [HP,0,0]));
  core.add(mesh(G.tor, M.trim, [3.70,3.70,0.34], [0,0,0], [0,0,0]));

  root.userData.rig = {cradle:cradle, shells:shells, core:core, cm:cm, ports:ports, GLC:GLC, GLV:GLV};
  return mergeBones(root);
}
export function updMutter(rig, o, dt){
  var i;
  rig.op = damp(rig.op === undefined ? 0 : rig.op, o.p2 ? 1 : 0, 2.6, dt);
  var op = rig.op;
  for (i = 0; i < 4; i++){
    rig.shells[i].rotation.x = -1.30*op;
    rig.shells[i].position.y = 0.40*op;
  }
  rig.cradle.rotation.y += dt*(0.20 + 0.9*o.tel + 1.6*op);
  rig.cradle.position.y = 3.40 + 0.16*Math.sin(o.t*0.8);
  rig.core.rotation.y -= dt*(0.6 + 2.4*op);
  rig.cm.scale.setScalar(1 + 0.06*Math.sin(o.t*2.6) + 0.30*o.tel*op);
  for (i = 0; i < 4; i++)
    rig.ports[i].scale.setScalar(1 + 0.22*Math.sin(o.t*3 + i) + 0.9*o.tel*(1-op));
  rig.GLC.emissiveIntensity = 2.2*(1-0.8*op) + 3.4*o.tel*(1-op) + 5*o.atk*(1-o.atk)*(1-op);
  rig.GLV.emissiveIntensity = 0.5 + 2.6*op + 3.4*o.tel*op + 6*o.atk*(1-o.atk)*op;
}